/**************
 Cart
 ***************/

// open cart

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        if (window.SLIDECART_STATE().settings.enabled) {
            setTimeout(function () {
                window.SLIDECART_UPDATE();
                window.SLIDECART_OPEN();
            }, 200);
        }
    });
});

// check is coming from the cart
if (document.referrer.includes("/cart")) {
    if (window.SLIDECART_STATE().settings.enabled) {
        setTimeout(function () {
            window.SLIDECART_UPDATE();
            window.SLIDECART_OPEN();
        }, 200);
    }
}